export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AccountNumber: { input: any; output: any; }
  BigInt: { input: any; output: any; }
  Byte: { input: any; output: any; }
  CountryCode: { input: any; output: any; }
  Cuid: { input: any; output: any; }
  Currency: { input: any; output: any; }
  DID: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateOfBirth: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  DateTimeISO: { input: any; output: any; }
  DeweyDecimal: { input: any; output: any; }
  Duration: { input: any; output: any; }
  EmailAddress: { input: any; output: any; }
  GUID: { input: any; output: any; }
  HSL: { input: any; output: any; }
  HSLA: { input: any; output: any; }
  HexColorCode: { input: any; output: any; }
  Hexadecimal: { input: any; output: any; }
  IBAN: { input: any; output: any; }
  IP: { input: any; output: any; }
  IPCPatent: { input: any; output: any; }
  IPv4: { input: any; output: any; }
  IPv6: { input: any; output: any; }
  ISBN: { input: any; output: any; }
  ISO8601Duration: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  JWT: { input: any; output: any; }
  LCCSubclass: { input: any; output: any; }
  Latitude: { input: any; output: any; }
  LocalDate: { input: any; output: any; }
  LocalDateTime: { input: any; output: any; }
  LocalEndTime: { input: any; output: any; }
  LocalTime: { input: any; output: any; }
  Locale: { input: any; output: any; }
  Long: { input: any; output: any; }
  Longitude: { input: any; output: any; }
  MAC: { input: any; output: any; }
  NegativeFloat: { input: any; output: any; }
  NegativeInt: { input: any; output: any; }
  NonEmptyString: { input: any; output: any; }
  NonNegativeFloat: { input: any; output: any; }
  NonNegativeInt: { input: any; output: any; }
  NonPositiveFloat: { input: any; output: any; }
  NonPositiveInt: { input: any; output: any; }
  ObjectID: { input: any; output: any; }
  PhoneNumber: { input: any; output: any; }
  Port: { input: any; output: any; }
  PositiveFloat: { input: any; output: any; }
  PositiveInt: { input: any; output: any; }
  PostalCode: { input: any; output: any; }
  RGB: { input: any; output: any; }
  RGBA: { input: any; output: any; }
  RoutingNumber: { input: any; output: any; }
  SESSN: { input: any; output: any; }
  SafeInt: { input: any; output: any; }
  SemVer: { input: any; output: any; }
  Time: { input: any; output: any; }
  TimeZone: { input: any; output: any; }
  Timestamp: { input: any; output: any; }
  URL: { input: any; output: any; }
  USCurrency: { input: any; output: any; }
  UUID: { input: any; output: any; }
  UnsignedFloat: { input: any; output: any; }
  UnsignedInt: { input: any; output: any; }
  UtcOffset: { input: any; output: any; }
  Void: { input: any; output: any; }
};

export type Account = {
  balanceInCents?: Maybe<Scalars['Float']['output']>;
  documents?: Maybe<Array<Maybe<Document>>>;
  id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<AccountStatus>;
  subaccounts?: Maybe<Array<Maybe<Subaccount>>>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccountType>;
};

export type AccountInput = {
  beneficiaryId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AccountType>;
};

export enum AccountProvider {
  AtomicBrokerage = 'ATOMIC_BROKERAGE',
  AtomicInvest = 'ATOMIC_INVEST'
}

export enum AccountStatus {
  Active = 'ACTIVE',
  Closed = 'CLOSED',
  InReview = 'IN_REVIEW',
  New = 'NEW',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export enum AccountType {
  Corporate = 'CORPORATE',
  FiveTwoNinePlan = 'FIVE_TWO_NINE_PLAN',
  GeneralInvesting = 'GENERAL_INVESTING',
  Individual = 'INDIVIDUAL',
  Individual_529 = 'INDIVIDUAL_529',
  IraRoth = 'IRA_ROTH',
  IraSep = 'IRA_SEP',
  IraTraditional = 'IRA_TRADITIONAL',
  Joint = 'JOINT',
  JuniorIraRoth = 'JUNIOR_IRA_ROTH',
  JuniorRothIra = 'JUNIOR_ROTH_IRA',
  RothIra = 'ROTH_IRA',
  TraditionalIra = 'TRADITIONAL_IRA'
}

export type ActionShareGoalInviteInput = {
  accountType?: InputMaybe<AccountType>;
  action: ShareGoalInviteAction;
  contributionsAfter18?: InputMaybe<Scalars['Boolean']['input']>;
  projectedRateOfReturn?: InputMaybe<Scalars['Float']['input']>;
  recurringDepositInCents?: InputMaybe<Scalars['Int']['input']>;
  recurringDepositSchedule?: InputMaybe<SipFrequency>;
  shareGoalInviteId: Scalars['String']['input'];
  targetAmountInCents?: InputMaybe<Scalars['Float']['input']>;
};

export type AddBeneficiaryInput = {
  dateOfBirth?: InputMaybe<Scalars['DateOfBirth']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  type: BeneficiaryType;
};

export type AddGoalInput = {
  accountType: AccountType;
  beneficiaryId: Scalars['String']['input'];
  contributionsAfter18?: InputMaybe<Scalars['Boolean']['input']>;
  goalName?: InputMaybe<Scalars['String']['input']>;
  goalType?: InputMaybe<GoalType>;
  projectedRateOfReturn?: InputMaybe<Scalars['Float']['input']>;
  recurringDepositInCents: Scalars['Int']['input'];
  recurringDepositSchedule: SipFrequency;
  targetAmountInCents: Scalars['Float']['input'];
  targetYear?: InputMaybe<Scalars['Int']['input']>;
};

export type AddressDetails = {
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  placeId: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  streetName?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
};

export type AddressPrediction = {
  description: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
};

export type AddressPredictions = {
  input: Scalars['String']['output'];
  predictions?: Maybe<Array<Maybe<AddressPrediction>>>;
};

export enum AffiliatedExchangeMic {
  Xnas = 'XNAS',
  Xndq = 'XNDQ',
  Xnfi = 'XNFI',
  Xngs = 'XNGS',
  Xnim = 'XNIM',
  Xnys = 'XNYS'
}

export type AssetClassExposure = {
  factorPercentage: Scalars['Float']['output'];
  name: PortfolioAssetExposureNames;
};

export type Authorization = {
  token: Scalars['String']['output'];
};

export type BankAccount = {
  accountNumber?: Maybe<Scalars['String']['output']>;
  assetColor?: Maybe<Scalars['String']['output']>;
  assetLogo?: Maybe<Scalars['String']['output']>;
  assetName?: Maybe<Scalars['String']['output']>;
  bankAccountId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  routingNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  useForBilling?: Maybe<Scalars['Boolean']['output']>;
};

export type BankLink = {
  assets?: Maybe<BankLinkAssets>;
  /** @deprecated No use for field */
  createdAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  providerInstitutionId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<BankLinkStatus>;
  /** @deprecated No use for field */
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type BankLinkAssets = {
  color?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum BankLinkProvider {
  Plaid = 'PLAID',
  Plain = 'PLAIN',
  Yodlee = 'YODLEE'
}

export enum BankLinkStatus {
  Connected = 'CONNECTED',
  Disconnected = 'DISCONNECTED'
}

export type Beneficiary = {
  dateOfBirth?: Maybe<Scalars['DateOfBirth']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  goals?: Maybe<Array<Maybe<Goal>>>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<BeneficiaryType>;
};

export enum BeneficiaryType {
  Adult = 'ADULT',
  Child = 'CHILD',
  Self = 'SELF'
}

export type BusinessAddress = {
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type ChangeRecurringDepositInput = {
  amountInCents?: InputMaybe<Scalars['Int']['input']>;
  frequency?: InputMaybe<SipFrequency>;
  pause?: InputMaybe<Scalars['Boolean']['input']>;
  sipId: Scalars['String']['input'];
};

export type Child = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dateOfBirth?: Maybe<Scalars['DateOfBirth']['output']>;
  /** @deprecated Use beneficiaries query instead */
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isFutureChild?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use beneficiaries -> goals -> sip query to get SIPs instead */
  sips?: Maybe<Array<Maybe<Sip>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CreateOneTimeDepositInput = {
  amountInCents: Scalars['Int']['input'];
  bankAccountId?: InputMaybe<Scalars['String']['input']>;
  executionDate: Scalars['Date']['input'];
  goalId: Scalars['String']['input'];
};

export type CreateTermsConsentInput = {
  viewedTimestamp: Scalars['DateTime']['input'];
};

export type CreateWithdrawalInput = {
  amountInCents: Scalars['Int']['input'];
  goalId: Scalars['String']['input'];
  type?: InputMaybe<WithdrawalType>;
};

export type DefaultProjectedRateOfReturnInput = {
  accountType: AccountType;
  beneficiaryId?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteInviteToShareGoalInput = {
  shareGoalInviteId: Scalars['String']['input'];
};

export enum DeviceType {
  Android = 'ANDROID',
  Ios = 'IOS'
}

export type Document = {
  bucket?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isRead?: Maybe<Scalars['Boolean']['output']>;
  isSigned?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<DocumentType>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum DocumentType {
  AccountStatement = 'ACCOUNT_STATEMENT',
  AtomicBrokerageAccountAgreement = 'ATOMIC_BROKERAGE_ACCOUNT_AGREEMENT',
  AtomicBrokerageAccountForm = 'ATOMIC_BROKERAGE_ACCOUNT_FORM',
  AtomicBrokerageCrs = 'ATOMIC_BROKERAGE_CRS',
  AtomicBrokerageGeneralDisclosures = 'ATOMIC_BROKERAGE_GENERAL_DISCLOSURES',
  AtomicBrokerageIndividual_529Agreement = 'ATOMIC_BROKERAGE_INDIVIDUAL_529_AGREEMENT',
  AtomicBrokeragePershingMarginAgreement = 'ATOMIC_BROKERAGE_PERSHING_MARGIN_AGREEMENT',
  AtomicBrokeragePrivacyPolicy = 'ATOMIC_BROKERAGE_PRIVACY_POLICY',
  AtomicInvestAdvisorFormAdv_2A = 'ATOMIC_INVEST_ADVISOR_FORM_ADV_2A',
  AtomicInvestAdvisorFormCrs = 'ATOMIC_INVEST_ADVISOR_FORM_CRS',
  AtomicInvestAdvisorFormCrscs = 'ATOMIC_INVEST_ADVISOR_FORM_CRSCS',
  AtomicInvestAdvisorGeneralDisclosures = 'ATOMIC_INVEST_ADVISOR_GENERAL_DISCLOSURES',
  AtomicInvestAdvisorTermsOfUse = 'ATOMIC_INVEST_ADVISOR_TERMS_OF_USE',
  AtomicInvestAssetManagementAgreement = 'ATOMIC_INVEST_ASSET_MANAGEMENT_AGREEMENT',
  AtomicInvestBrokerageAgreement = 'ATOMIC_INVEST_BROKERAGE_AGREEMENT',
  AtomicInvestBulkFundingAgreement = 'ATOMIC_INVEST_BULK_FUNDING_AGREEMENT',
  AtomicInvestCorporateAgreement = 'ATOMIC_INVEST_CORPORATE_AGREEMENT',
  AtomicInvestCustodialAgreement = 'ATOMIC_INVEST_CUSTODIAL_AGREEMENT',
  AtomicInvestIndividual_529Agreement = 'ATOMIC_INVEST_INDIVIDUAL_529_AGREEMENT',
  AtomicInvestInvestmentManagementAgreement = 'ATOMIC_INVEST_INVESTMENT_MANAGEMENT_AGREEMENT',
  AtomicInvestJointAgreement = 'ATOMIC_INVEST_JOINT_AGREEMENT',
  AtomicInvestPrivacyNotice = 'ATOMIC_INVEST_PRIVACY_NOTICE',
  AtomicInvestRothIraAgreement = 'ATOMIC_INVEST_ROTH_IRA_AGREEMENT',
  AtomicInvestTraditionalIraAgreement = 'ATOMIC_INVEST_TRADITIONAL_IRA_AGREEMENT',
  AtomicInvestTrustAgreement = 'ATOMIC_INVEST_TRUST_AGREEMENT',
  AtomicInvestW8Bene = 'ATOMIC_INVEST_W8BENE',
  Miscellaneous = 'MISCELLANEOUS',
  Performance = 'PERFORMANCE',
  Tax = 'TAX',
  TradeConfirmation = 'TRADE_CONFIRMATION'
}

export type EditGoalInput = {
  contributionsAfter18?: InputMaybe<Scalars['Boolean']['input']>;
  goalId: Scalars['String']['input'];
  goalName?: InputMaybe<Scalars['String']['input']>;
  goalType?: InputMaybe<GoalType>;
  projectedRateOfReturn?: InputMaybe<Scalars['Float']['input']>;
  targetAmountInCents?: InputMaybe<Scalars['Float']['input']>;
  targetYear?: InputMaybe<Scalars['Int']['input']>;
};

export type GetBankLinkTokenInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type GetBankLinkTokenPayload = {
  provider: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type Goal = {
  contributionsAfter18?: Maybe<Scalars['Boolean']['output']>;
  currentAmountInCents?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  partners?: Maybe<Array<Maybe<Partner>>>;
  projectedRateOfReturn?: Maybe<Scalars['Float']['output']>;
  shared?: Maybe<Scalars['Boolean']['output']>;
  sips?: Maybe<Array<Maybe<Sip>>>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<GoalStatus>;
  targetAmountInCents?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<GoalType>;
};

export enum GoalStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
  New = 'NEW',
  OnHold = 'ON_HOLD'
}

export enum GoalType {
  Custom = 'CUSTOM',
  Education = 'EDUCATION',
  EmergencyFund = 'EMERGENCY_FUND',
  GenerationalWealth = 'GENERATIONAL_WEALTH',
  House = 'HOUSE',
  NewCar = 'NEW_CAR',
  Retirement = 'RETIREMENT',
  Vacation = 'VACATION'
}

export type InitiateLoginWithPhoneInput = {
  phoneNumber: Scalars['String']['input'];
};

export type InitiateResetPasswordInput = {
  email: Scalars['String']['input'];
};

export type InitiateUserPrefill = {
  redirectUrl?: Maybe<Scalars['String']['output']>;
};

export enum InvestmentPrinciple {
  BuildResilientInfrastructure = 'BUILD_RESILIENT_INFRASTRUCTURE',
  EmpowerWomen = 'EMPOWER_WOMEN',
  EndHunger = 'END_HUNGER',
  EndPoverty = 'END_POVERTY',
  EnsureCleanEnergy = 'ENSURE_CLEAN_ENERGY',
  EnsureCleanWater = 'ENSURE_CLEAN_WATER',
  EnsureEducation = 'ENSURE_EDUCATION',
  EnsureHealth = 'ENSURE_HEALTH',
  EnsureSustainableConsumption = 'ENSURE_SUSTAINABLE_CONSUMPTION',
  ExcludeAbortifacients = 'EXCLUDE_ABORTIFACIENTS',
  ExcludeAlcohol = 'EXCLUDE_ALCOHOL',
  ExcludeAnimalCruelty = 'EXCLUDE_ANIMAL_CRUELTY',
  ExcludeCannabis = 'EXCLUDE_CANNABIS',
  ExcludeCivilianFirearms = 'EXCLUDE_CIVILIAN_FIREARMS',
  ExcludeContraceptives = 'EXCLUDE_CONTRACEPTIVES',
  ExcludeGambling = 'EXCLUDE_GAMBLING',
  ExcludeGmo = 'EXCLUDE_GMO',
  ExcludeHazardousPesticides = 'EXCLUDE_HAZARDOUS_PESTICIDES',
  ExcludeMilitary = 'EXCLUDE_MILITARY',
  ExcludePork = 'EXCLUDE_PORK',
  ExcludePornography = 'EXCLUDE_PORNOGRAPHY',
  ExcludePredatoryLending = 'EXCLUDE_PREDATORY_LENDING',
  ExcludePrivatePrisons = 'EXCLUDE_PRIVATE_PRISONS',
  ExcludeStemCells = 'EXCLUDE_STEM_CELLS',
  ExcludeTobacco = 'EXCLUDE_TOBACCO',
  MakeCitiesSustainable = 'MAKE_CITIES_SUSTAINABLE',
  PromoteDecentWork = 'PROMOTE_DECENT_WORK',
  ProtectAnimalWelfare = 'PROTECT_ANIMAL_WELFARE',
  ProtectMarineLife = 'PROTECT_MARINE_LIFE',
  ProtectTerrestrialLife = 'PROTECT_TERRESTRIAL_LIFE',
  ReduceInequality = 'REDUCE_INEQUALITY',
  SafeguardPeace = 'SAFEGUARD_PEACE',
  TakeClimateAction = 'TAKE_CLIMATE_ACTION'
}

export type InviteToShareGoalInput = {
  goalId: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type Invoice = {
  amount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  providerDiscountId?: Maybe<Scalars['String']['output']>;
  providerInvoiceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type LoginWithOAuthInput = {
  oauthToken: Scalars['String']['input'];
};

export type LoginWithPhoneInput = {
  code: Scalars['Int']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type Mutation = {
  actionShareGoalInvite?: Maybe<Goal>;
  addBeneficiary?: Maybe<Beneficiary>;
  addGoal?: Maybe<Goal>;
  changeRecurringDeposit: Sip;
  closeAccount?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated This will be removed in the next release */
  confirmUserOnboarding?: Maybe<User>;
  createOneTimeDeposit: Transaction;
  createTermsConsent?: Maybe<Scalars['Boolean']['output']>;
  createTradeConfirmationsConsent?: Maybe<Scalars['Boolean']['output']>;
  createWithdrawal: Transaction;
  deleteInviteToShareGoal?: Maybe<Scalars['Boolean']['output']>;
  editGoal?: Maybe<Goal>;
  initiateLoginWithPhone: Scalars['Boolean']['output'];
  initiateResetPassword: Scalars['Boolean']['output'];
  initiateUserPrefill?: Maybe<InitiateUserPrefill>;
  inviteToShareGoal?: Maybe<SentShareGoalInvite>;
  loginUser: Authorization;
  loginWithOAuth: Authorization;
  loginWithPhone: Authorization;
  processPublicToken?: Maybe<Scalars['Boolean']['output']>;
  registerUser: Authorization;
  removePartnerFromGoal?: Maybe<Goal>;
  resendInviteToShareGoal?: Maybe<SentShareGoalInvite>;
  resetPassword: Scalars['Boolean']['output'];
  setUserAffiliatedExchanges?: Maybe<Array<Maybe<UserAffiliatedExchange>>>;
  setUserControlCorporations?: Maybe<Array<Maybe<UserControlCorporation>>>;
  setUserFinancialProfile?: Maybe<UserFinancialProfile>;
  setUserIdentity?: Maybe<User>;
  setUserInvestmentPrinciples?: Maybe<Array<Maybe<UserInvestmentPrinciple>>>;
  setUserRestrictions?: Maybe<Array<Maybe<UserRestriction>>>;
  setUserTaxProfile?: Maybe<User>;
  validateUserPrefill?: Maybe<Scalars['Boolean']['output']>;
  verifyPhoneNumber?: Maybe<Scalars['Boolean']['output']>;
  verifyPromotionCode?: Maybe<PromotionCode>;
};


export type MutationActionShareGoalInviteArgs = {
  input: ActionShareGoalInviteInput;
};


export type MutationAddBeneficiaryArgs = {
  input: AddBeneficiaryInput;
};


export type MutationAddGoalArgs = {
  input: AddGoalInput;
};


export type MutationChangeRecurringDepositArgs = {
  input: ChangeRecurringDepositInput;
};


export type MutationCreateOneTimeDepositArgs = {
  input: CreateOneTimeDepositInput;
};


export type MutationCreateTermsConsentArgs = {
  input: CreateTermsConsentInput;
};


export type MutationCreateWithdrawalArgs = {
  input: CreateWithdrawalInput;
};


export type MutationDeleteInviteToShareGoalArgs = {
  input: DeleteInviteToShareGoalInput;
};


export type MutationEditGoalArgs = {
  input: EditGoalInput;
};


export type MutationInitiateLoginWithPhoneArgs = {
  input: InitiateLoginWithPhoneInput;
};


export type MutationInitiateResetPasswordArgs = {
  input: InitiateResetPasswordInput;
};


export type MutationInviteToShareGoalArgs = {
  input: InviteToShareGoalInput;
};


export type MutationLoginUserArgs = {
  input: LoginInput;
};


export type MutationLoginWithOAuthArgs = {
  input: LoginWithOAuthInput;
};


export type MutationLoginWithPhoneArgs = {
  input: LoginWithPhoneInput;
};


export type MutationProcessPublicTokenArgs = {
  input: ProcessPublicTokenInput;
};


export type MutationRegisterUserArgs = {
  input: RegisterInput;
};


export type MutationRemovePartnerFromGoalArgs = {
  input: RemovePartnerFromGoalInput;
};


export type MutationResendInviteToShareGoalArgs = {
  input: ResendInviteToShareGoalInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationSetUserAffiliatedExchangesArgs = {
  input: SetUserAffiliatedExchanges;
};


export type MutationSetUserControlCorporationsArgs = {
  input: SetUserControlCorporations;
};


export type MutationSetUserFinancialProfileArgs = {
  input: SetUserFinancialProfile;
};


export type MutationSetUserIdentityArgs = {
  input: SetUserIdentity;
};


export type MutationSetUserInvestmentPrinciplesArgs = {
  input: SetUserInvestmentPrinciples;
};


export type MutationSetUserRestrictionsArgs = {
  input: SetUserRestrictions;
};


export type MutationSetUserTaxProfileArgs = {
  input: SetUserTaxProfile;
};


export type MutationValidateUserPrefillArgs = {
  input: ValidateUserPrefill;
};


export type MutationVerifyPhoneNumberArgs = {
  input: VerifyPhoneNumber;
};


export type MutationVerifyPromotionCodeArgs = {
  code: Scalars['String']['input'];
};

export enum OccupationIndustry {
  Accounting = 'ACCOUNTING',
  AdvertisingMarketing = 'ADVERTISING__MARKETING',
  AerospaceDefense = 'AEROSPACE__DEFENSE',
  AgricultureForestry = 'AGRICULTURE__FORESTRY',
  AmusementAndRecreation = 'AMUSEMENT_AND_RECREATION',
  AnimalServicesAndVeterinary = 'ANIMAL_SERVICES_AND_VETERINARY',
  ArchitectureDesign = 'ARCHITECTURE__DESIGN',
  ArtsAntiques = 'ARTS__ANTIQUES',
  AthleticsFitness = 'ATHLETICS__FITNESS',
  Automotive = 'AUTOMOTIVE',
  Aviation = 'AVIATION',
  BarNightclubAdultEntertainmentClub = 'BAR__NIGHTCLUB__ADULT_ENTERTAINMENT_CLUB',
  Childcare = 'CHILDCARE',
  CleaningJanitorialHousekeeping = 'CLEANING__JANITORIAL__HOUSEKEEPING',
  CommunicationsTelecommunications = 'COMMUNICATIONS__TELECOMMUNICATIONS',
  ConstructionCarpentryLandscaping = 'CONSTRUCTION__CARPENTRY__LANDSCAPING',
  ConvenienceStoreLiquorStoreGasStation = 'CONVENIENCE_STORE__LIQUOR_STORE__GAS_STATION',
  CustomerServiceAndSupport = 'CUSTOMER_SERVICE_AND_SUPPORT',
  Education = 'EDUCATION',
  EmbassyConsulate = 'EMBASSY__CONSULATE',
  Energy = 'ENERGY',
  Engineering = 'ENGINEERING',
  FashionClothing = 'FASHION__CLOTHING',
  FinancialServices = 'FINANCIAL_SERVICES',
  FirearmsAndExplosives = 'FIREARMS_AND_EXPLOSIVES',
  GamingCasinoCardClub = 'GAMING__CASINO__CARD_CLUB',
  GovernmentPublicAdministration = 'GOVERNMENT__PUBLIC_ADMINISTRATION',
  GrocerySupermarket = 'GROCERY__SUPERMARKET',
  HealthcareMedicalServices = 'HEALTHCARE__MEDICAL_SERVICES',
  HotelHospitality = 'HOTEL__HOSPITALITY',
  ImportExport = 'IMPORT__EXPORT',
  IndustryNotApplicableUnemployed = 'INDUSTRY__NOT__APPLICABLE__UNEMPLOYED',
  InformationTechnology = 'INFORMATION_TECHNOLOGY',
  Insurance = 'INSURANCE',
  JewelryGemsAndPreciousMetals = 'JEWELRY_GEMS_AND_PRECIOUS_METALS',
  LegalServicesPublicSafety = 'LEGAL_SERVICES__PUBLIC_SAFETY',
  LogisticsSupplyChain = 'LOGISTICS__SUPPLY_CHAIN',
  Manufacturing = 'MANUFACTURING',
  Maritime = 'MARITIME',
  MediaEntertainment = 'MEDIA__ENTERTAINMENT',
  MiningOilAndGas = 'MINING_OIL_AND_GAS',
  MoneyServicesBusinesses = 'MONEY_SERVICES_BUSINESSES',
  NonProfitNgoCharity = 'NON_PROFIT__NGO__CHARITY',
  OtherIndustry = 'OTHER_INDUSTRY',
  ParkingAndCarWashes = 'PARKING_AND_CAR_WASHES',
  PawnShopsBrokers = 'PAWN_SHOPS__BROKERS',
  PersonalCareHygiene = 'PERSONAL_CARE__HYGIENE',
  Pharmaceuticals = 'PHARMACEUTICALS',
  PrintingPublishing = 'PRINTING__PUBLISHING',
  ProfessionalCivicOrganizations = 'PROFESSIONAL__CIVIC_ORGANIZATIONS',
  RealEstate = 'REAL_ESTATE',
  ReligiousOrganization = 'RELIGIOUS_ORGANIZATION',
  RepairServices = 'REPAIR_SERVICES',
  RestaurantFoodService = 'RESTAURANT__FOOD_SERVICE',
  RetailSalesRetailTrade = 'RETAIL_SALES__RETAIL_TRADE',
  Retirement = 'RETIREMENT',
  ScienceAndBiotechnology = 'SCIENCE_AND_BIOTECHNOLOGY',
  Security = 'SECURITY',
  Transportation = 'TRANSPORTATION',
  Travel = 'TRAVEL',
  Utilities = 'UTILITIES',
  WholesaleSalesTrade = 'WHOLESALE_SALES__TRADE'
}

export enum OccupationTitle {
  AccountantAuditorBookkeeper = 'ACCOUNTANT__AUDITOR__BOOKKEEPER',
  Adjuster = 'ADJUSTER',
  AdvertiserMarketerPrProfessional = 'ADVERTISER__MARKETER__PR_PROFESSIONAL',
  AirTrafficController = 'AIR_TRAFFIC_CONTROLLER',
  AmbassadorConsulateProfessional = 'AMBASSADOR__CONSULATE_PROFESSIONAL',
  Analyst = 'ANALYST',
  Appraiser = 'APPRAISER',
  ArchitectDesigner = 'ARCHITECT__DESIGNER',
  ArtistPerformerActorDancer = 'ARTIST__PERFORMER__ACTOR__DANCER',
  AssistantExecutiveAssistant = 'ASSISTANT__EXECUTIVE_ASSISTANT',
  Athlete = 'ATHLETE',
  AttorneyJudgeLegalProfessional = 'ATTORNEY__JUDGE__LEGAL_PROFESSIONAL',
  Auctioneer = 'AUCTIONEER',
  BankerLendingProfessional = 'BANKER__LENDING_PROFESSIONAL',
  BarberBeauticianHairstylist = 'BARBER__BEAUTICIAN__HAIRSTYLIST',
  BrokerRegisteredRep = 'BROKER__REGISTERED_REP',
  BusinessExecutive = 'BUSINESS_EXECUTIVE',
  BusinessOwner = 'BUSINESS_OWNER',
  Caregiver = 'CAREGIVER',
  CarpenterConstructionWorkerContractor = 'CARPENTER__CONSTRUCTION_WORKER__CONTRACTOR',
  Cashier = 'CASHIER',
  ChefCook = 'CHEF__COOK',
  Chiropractor = 'CHIROPRACTOR',
  CivilServant = 'CIVIL_SERVANT',
  Clergy = 'CLERGY',
  Clerk = 'CLERK',
  ComplianceRegulatoryProfessional = 'COMPLIANCE__REGULATORY_PROFESSIONAL',
  Consultant = 'CONSULTANT',
  CounselorTherapist = 'COUNSELOR__THERAPIST',
  CustomerServiceRepresentative = 'CUSTOMER_SERVICE_REPRESENTATIVE',
  Dealer = 'DEALER',
  Dentist = 'DENTIST',
  Distributor = 'DISTRIBUTOR',
  DoctorSurgeonPhysician = 'DOCTOR__SURGEON__PHYSICIAN',
  Driver = 'DRIVER',
  Engineer = 'ENGINEER',
  Exterminator = 'EXTERMINATOR',
  FactoryWarehouseWorker = 'FACTORY__WAREHOUSE_WORKER',
  FarmerRancher = 'FARMER__RANCHER',
  FinancialPlannerAdvisor = 'FINANCIAL_PLANNER__ADVISOR',
  FlightAttendant = 'FLIGHT_ATTENDANT',
  HumanResourcesProfessional = 'HUMAN_RESOURCES_PROFESSIONAL',
  ImporterExporter = 'IMPORTER__EXPORTER',
  InspectorInvestigator = 'INSPECTOR__INVESTIGATOR',
  Investor = 'INVESTOR',
  ItProfessionalItAssociate = 'IT_PROFESSIONAL__IT_ASSOCIATE',
  Janitor = 'JANITOR',
  Jeweler = 'JEWELER',
  Laborer = 'LABORER',
  Landscaper = 'LANDSCAPER',
  Mechanic = 'MECHANIC',
  MilitaryOfficerOrAssociated = 'MILITARY_OFFICER_OR_ASSOCIATED',
  MorticianFuneralDirector = 'MORTICIAN__FUNERAL_DIRECTOR',
  Nurse = 'NURSE',
  OfficeAssociate = 'OFFICE_ASSOCIATE',
  Pharmacist = 'PHARMACIST',
  PhysicalTherapist = 'PHYSICAL_THERAPIST',
  Pilot = 'PILOT',
  PoliceOfficerFirefighterLawEnforcementProfessional = 'POLICE_OFFICER__FIREFIGHTER__LAW_ENFORCEMENT_PROFESSIONAL',
  Politician = 'POLITICIAN',
  ProjectManager = 'PROJECT_MANAGER',
  RealEstateProfessional = 'REAL_ESTATE_PROFESSIONAL',
  Researcher = 'RESEARCHER',
  Salesperson = 'SALESPERSON',
  Scientist = 'SCIENTIST',
  SeamstressTailor = 'SEAMSTRESS__TAILOR',
  SecurityGuard = 'SECURITY_GUARD',
  SocialWorker = 'SOCIAL_WORKER',
  TeacherProfessor = 'TEACHER__PROFESSOR',
  Technician = 'TECHNICIAN',
  Teller = 'TELLER',
  TitleNotApplicableUnemployed = 'TITLE__NOT__APPLICABLE__UNEMPLOYED',
  TradespersonCraftsperson = 'TRADESPERSON__CRAFTSPERSON',
  TrainerInstructor = 'TRAINER__INSTRUCTOR',
  Underwriter = 'UNDERWRITER',
  Veterinarian = 'VETERINARIAN',
  WriterJournalistEditor = 'WRITER__JOURNALIST__EDITOR'
}

export type Partner = {
  contributionsInCents?: Maybe<Scalars['Float']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  recurringDepositInCents?: Maybe<Scalars['Float']['output']>;
  recurringDepositSchedule?: Maybe<SipFrequency>;
  returnsInCents?: Maybe<Scalars['Float']['output']>;
};

export type PartnerGoalContributions = {
  contributionsInCents?: Maybe<Scalars['Float']['output']>;
  partnerFirstName?: Maybe<Scalars['String']['output']>;
  partnerId?: Maybe<Scalars['String']['output']>;
  partnerLastName?: Maybe<Scalars['String']['output']>;
  recurringDepositInCents?: Maybe<Scalars['Int']['output']>;
  recurringDepositSchedule?: Maybe<SipFrequency>;
  returnsInCents?: Maybe<Scalars['Float']['output']>;
};

export enum PortfolioAssetExposureNames {
  Alternative = 'ALTERNATIVE',
  Bond = 'BOND',
  Cash = 'CASH',
  CommonStock = 'COMMON_STOCK',
  Crypto = 'CRYPTO',
  ExchangeTradedProduct = 'EXCHANGE_TRADED_PRODUCT',
  ForeignBond = 'FOREIGN_BOND',
  ForeignStock = 'FOREIGN_STOCK',
  MutualFund = 'MUTUAL_FUND',
  Option = 'OPTION',
  Other = 'OTHER',
  RealEstate = 'REAL_ESTATE'
}

export type PortfolioBreakdown = {
  assetClassExposures?: Maybe<Array<Maybe<AssetClassExposure>>>;
  contributionsInCents?: Maybe<Scalars['Float']['output']>;
  returnsInCents?: Maybe<Scalars['Float']['output']>;
  sectorExposures?: Maybe<Array<Maybe<SectorExposure>>>;
  totalValueInCents?: Maybe<Scalars['Float']['output']>;
};

export type PortfolioBreakdownInput = {
  beneficiaryId?: InputMaybe<Scalars['String']['input']>;
  goalId?: InputMaybe<Scalars['String']['input']>;
};

export type PortfolioPerformanceGraph = {
  grossReturnAbsolute?: Maybe<Scalars['Float']['output']>;
  grossReturnPercentage?: Maybe<Scalars['Float']['output']>;
  nodes?: Maybe<Array<Maybe<PortfolioPerformanceGraphNode>>>;
};

export type PortfolioPerformanceGraphInput = {
  beneficiaryId?: InputMaybe<Scalars['String']['input']>;
  goalId?: InputMaybe<Scalars['String']['input']>;
  nodeCount?: InputMaybe<Scalars['Int']['input']>;
  timeFrame: PortfolioPerformanceGraphTimeFrame;
};

export type PortfolioPerformanceGraphNode = {
  timestamp: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
};

export enum PortfolioPerformanceGraphTimeFrame {
  FiveYear = 'FIVE_YEAR',
  OneDay = 'ONE_DAY',
  OneMonth = 'ONE_MONTH',
  OneWeek = 'ONE_WEEK',
  OneYear = 'ONE_YEAR',
  SixMonth = 'SIX_MONTH',
  TenYear = 'TEN_YEAR',
  ThreeMonth = 'THREE_MONTH'
}

export type PortfolioPosition = {
  changeTodayAmountInCents?: Maybe<Scalars['Float']['output']>;
  changeTodayPercentage?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  sharePriceInCents: Scalars['Float']['output'];
  shares: Scalars['Float']['output'];
  symbol: Scalars['String']['output'];
  totalValueInCents: Scalars['Float']['output'];
};

export type PortfolioPositionsInput = {
  beneficiaryId?: InputMaybe<Scalars['String']['input']>;
  goalId?: InputMaybe<Scalars['String']['input']>;
};

export enum PortfolioSectorExposureNames {
  BusinessServices = 'BUSINESS_SERVICES',
  CommunicationServices = 'COMMUNICATION_SERVICES',
  ConsumerDiscretionary = 'CONSUMER_DISCRETIONARY',
  ConsumerServices = 'CONSUMER_SERVICES',
  ConsumerStaples = 'CONSUMER_STAPLES',
  Crypto = 'CRYPTO',
  Energy = 'ENERGY',
  Etf = 'ETF',
  Fiat = 'FIAT',
  Financials = 'FINANCIALS',
  FixedIncome = 'FIXED_INCOME',
  HealthCare = 'HEALTH_CARE',
  Industrials = 'INDUSTRIALS',
  InformationTechnology = 'INFORMATION_TECHNOLOGY',
  Materials = 'MATERIALS',
  Other = 'OTHER',
  RealEstate = 'REAL_ESTATE',
  Utilities = 'UTILITIES'
}

export type ProcessPublicTokenInput = {
  institutionId: Scalars['String']['input'];
  publicToken: Scalars['String']['input'];
};

export type PromotionCode = {
  active?: Maybe<Scalars['Boolean']['output']>;
  amountOff?: Maybe<Scalars['Float']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentOff?: Maybe<Scalars['Float']['output']>;
};

export type Query = {
  /** @deprecated Use input instead of individual arguments */
  account?: Maybe<Array<Account>>;
  /** Get details for an address */
  addressDetails?: Maybe<AddressDetails>;
  /** Get suggestions for address */
  addressPredictions?: Maybe<AddressPredictions>;
  beneficiaries?: Maybe<Array<Maybe<Beneficiary>>>;
  /** Look up business address by name */
  businessAddress?: Maybe<BusinessAddress>;
  countries?: Maybe<Scalars['JSON']['output']>;
  /** Get current supported version */
  currentVersion?: Maybe<Scalars['String']['output']>;
  defaultProjectedRateOfReturn?: Maybe<Scalars['Float']['output']>;
  getBankAccounts?: Maybe<Array<BankAccount>>;
  getBankLinkToken?: Maybe<GetBankLinkTokenPayload>;
  getBankLinks?: Maybe<Array<Maybe<BankLink>>>;
  goals?: Maybe<Array<Maybe<Goal>>>;
  industries?: Maybe<Scalars['JSON']['output']>;
  /** Check if input version is supported or not */
  isSupportedVersion?: Maybe<Scalars['Boolean']['output']>;
  isUserOnWaitlist?: Maybe<Scalars['Boolean']['output']>;
  occupations?: Maybe<Scalars['JSON']['output']>;
  portfolioBreakdown: PortfolioBreakdown;
  portfolioPerformanceGraph: PortfolioPerformanceGraph;
  portfolioPositions: Array<Maybe<PortfolioPosition>>;
  receivedShareGoalInvites?: Maybe<Array<Maybe<ReceivedShareGoalInvite>>>;
  sentShareGoalInvites?: Maybe<Array<Maybe<SentShareGoalInvite>>>;
  transactions?: Maybe<TransactionQueryResponse>;
  user?: Maybe<User>;
  userKYCCompletionLink?: Maybe<Scalars['String']['output']>;
  userPrefillData?: Maybe<UserPrefillData>;
};


export type QueryAccountArgs = {
  childId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<AccountInput>;
  type?: InputMaybe<AccountType>;
};


export type QueryAddressDetailsArgs = {
  placeId: Scalars['String']['input'];
};


export type QueryAddressPredictionsArgs = {
  input: Scalars['String']['input'];
};


export type QueryBeneficiariesArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBusinessAddressArgs = {
  input: Scalars['String']['input'];
};


export type QueryDefaultProjectedRateOfReturnArgs = {
  input: DefaultProjectedRateOfReturnInput;
};


export type QueryGetBankLinkTokenArgs = {
  input?: InputMaybe<GetBankLinkTokenInput>;
};


export type QueryGoalsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIsSupportedVersionArgs = {
  version: Scalars['String']['input'];
};


export type QueryPortfolioBreakdownArgs = {
  input: PortfolioBreakdownInput;
};


export type QueryPortfolioPerformanceGraphArgs = {
  input: PortfolioPerformanceGraphInput;
};


export type QueryPortfolioPositionsArgs = {
  input: PortfolioPositionsInput;
};


export type QuerySentShareGoalInvitesArgs = {
  goalId: Scalars['String']['input'];
};


export type QueryTransactionsArgs = {
  input: TransactionsInput;
};

export type ReceivedShareGoalInvite = {
  beneficiaryType?: Maybe<BeneficiaryType>;
  contributionsAfter18?: Maybe<Scalars['Boolean']['output']>;
  contributionsInCents?: Maybe<Scalars['Float']['output']>;
  currentAmountInCents?: Maybe<Scalars['Float']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  expiry?: Maybe<Scalars['DateTime']['output']>;
  goalName?: Maybe<Scalars['String']['output']>;
  goalType?: Maybe<GoalType>;
  id?: Maybe<Scalars['String']['output']>;
  inviterFirstName?: Maybe<Scalars['String']['output']>;
  inviterLastName?: Maybe<Scalars['String']['output']>;
  partnerGoalContributions?: Maybe<Array<Maybe<PartnerGoalContributions>>>;
  projectedRateOfReturn?: Maybe<Scalars['Float']['output']>;
  recurringDepositInCents?: Maybe<Scalars['Int']['output']>;
  recurringDepositSchedule?: Maybe<SipFrequency>;
  returnsInCents?: Maybe<Scalars['Float']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<ShareGoalInviteStatus>;
  targetAmountInCents?: Maybe<Scalars['Float']['output']>;
  targetYear?: Maybe<Scalars['Int']['output']>;
};

export type RegisterInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  promotionCode?: InputMaybe<Scalars['String']['input']>;
};

export type RemovePartnerFromGoalInput = {
  goalId: Scalars['String']['input'];
  partnerId: Scalars['String']['input'];
};

export type ResendInviteToShareGoalInput = {
  shareGoalInviteId: Scalars['String']['input'];
};

export type ResetPasswordInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export enum RiskScore {
  Eight = 'EIGHT',
  Five = 'FIVE',
  Four = 'FOUR',
  Nine = 'NINE',
  One = 'ONE',
  Seven = 'SEVEN',
  Six = 'SIX',
  Ten = 'TEN',
  Three = 'THREE',
  Two = 'TWO'
}

export type SectorExposure = {
  factorPercentage: Scalars['Float']['output'];
  name: PortfolioSectorExposureNames;
};

export type SentShareGoalInvite = {
  expiry?: Maybe<Scalars['DateTime']['output']>;
  goalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ShareGoalInviteStatus>;
};

export type SetUserAffiliatedExchanges = {
  exchangeMics: Array<InputMaybe<AffiliatedExchangeMic>>;
};

export type SetUserControlCorporations = {
  corporationNames: Array<InputMaybe<Scalars['String']['input']>>;
};

export type SetUserFinancialProfile = {
  downturnReaction?: InputMaybe<UserDownturnReaction>;
  employerAddressCity?: InputMaybe<Scalars['String']['input']>;
  employerAddressCountry?: InputMaybe<Scalars['String']['input']>;
  employerAddressPostalCode?: InputMaybe<Scalars['String']['input']>;
  employerAddressState?: InputMaybe<Scalars['String']['input']>;
  employerAddressStreet?: InputMaybe<Scalars['String']['input']>;
  employerAddressUnitNo?: InputMaybe<Scalars['String']['input']>;
  employerName?: InputMaybe<Scalars['String']['input']>;
  employmentStatus?: InputMaybe<UserEmploymentStatus>;
  investmentHorizon?: InputMaybe<UserInvestmentHorizon>;
  investmentPriority?: InputMaybe<UserInvestmentPriority>;
  isFamilyPoliticallyExposed?: InputMaybe<Scalars['Boolean']['input']>;
  isFinraAffiliated?: InputMaybe<Scalars['Boolean']['input']>;
  isPoliticallyExposed?: InputMaybe<Scalars['Boolean']['input']>;
  occupationIndustry?: InputMaybe<OccupationIndustry>;
  occupationTitle?: InputMaybe<OccupationTitle>;
  trustedContactAddressCity?: InputMaybe<Scalars['String']['input']>;
  trustedContactAddressCountry?: InputMaybe<Scalars['String']['input']>;
  trustedContactAddressPostalCode?: InputMaybe<Scalars['String']['input']>;
  trustedContactAddressState?: InputMaybe<Scalars['String']['input']>;
  trustedContactAddressStreet?: InputMaybe<Scalars['String']['input']>;
  trustedContactAddressUnitNo?: InputMaybe<Scalars['String']['input']>;
  trustedContactEmail?: InputMaybe<Scalars['String']['input']>;
  trustedContactFirstName?: InputMaybe<Scalars['String']['input']>;
  trustedContactLastName?: InputMaybe<Scalars['String']['input']>;
  trustedContactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type SetUserIdentity = {
  address?: InputMaybe<UserAddressInput>;
  countryOfCitizenship?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  preferredName?: InputMaybe<Scalars['String']['input']>;
  residenceStatus?: InputMaybe<UserResidenceStatus>;
};

export type SetUserInvestmentPrinciples = {
  principles: Array<InputMaybe<InvestmentPrinciple>>;
};

export type SetUserRestrictions = {
  tickerSymbols: Array<InputMaybe<Scalars['String']['input']>>;
};

export type SetUserTaxProfile = {
  countryOfTaxResidence?: InputMaybe<Scalars['String']['input']>;
  stateOfTaxResidence?: InputMaybe<Scalars['String']['input']>;
  taxId: Scalars['String']['input'];
  taxIdType?: InputMaybe<UserTaxIdType>;
};

export enum ShareGoalInviteAction {
  Accept = 'ACCEPT',
  Reject = 'REJECT'
}

export enum ShareGoalInviteStatus {
  Accepted = 'ACCEPTED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type Sip = {
  id?: Maybe<Scalars['String']['output']>;
  paused?: Maybe<Scalars['Boolean']['output']>;
  recurringDepositInCents?: Maybe<Scalars['Int']['output']>;
  recurringDepositSchedule?: Maybe<SipFrequency>;
  status?: Maybe<SipStatus>;
};

export enum SipFrequency {
  Annually = 'ANNUALLY',
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export enum SipStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Closed = 'CLOSED',
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS',
  Modifying = 'MODIFYING',
  New = 'NEW',
  OnHold = 'ON_HOLD'
}

export type Subaccount = {
  balanceInCents?: Maybe<Scalars['Float']['output']>;
  childId?: Maybe<Scalars['String']['output']>;
  enableDynamicRisk?: Maybe<Scalars['Boolean']['output']>;
  goal?: Maybe<Goal>;
  id?: Maybe<Scalars['String']['output']>;
  riskScore?: Maybe<RiskScore>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<SubaccountType>;
};

export enum SubaccountType {
  CustomIndexing = 'CUSTOM_INDEXING',
  SelfDirected = 'SELF_DIRECTED'
}

export type Subscription = {
  billingInterval?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  nextBillingDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Trialing = 'TRIALING'
}

export enum SupportedCurrenciesEnum {
  Cad = 'CAD',
  Usd = 'USD'
}

export type Transaction = {
  amountInCents?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<TransactionLabel>;
  reason?: Maybe<Scalars['String']['output']>;
  status?: Maybe<TransactionStatus>;
  type?: Maybe<TransactionType>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export enum TransactionLabel {
  Adjustment = 'ADJUSTMENT',
  Deposit = 'DEPOSIT',
  Interest = 'INTEREST',
  Reward = 'REWARD',
  Withdrawal = 'WITHDRAWAL'
}

export type TransactionQueryResponse = {
  elements: Array<Maybe<Transaction>>;
  nextCursor?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
};

export enum TransactionStatus {
  Cancelled = 'CANCELLED',
  Committed = 'COMMITTED',
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  MfaRequired = 'MFA_REQUIRED',
  New = 'NEW',
  Processing = 'PROCESSING',
  Scheduled = 'SCHEDULED',
  TradeInitiated = 'TRADE_INITIATED'
}

export enum TransactionTime {
  Past = 'PAST',
  Upcoming = 'UPCOMING'
}

export enum TransactionType {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export type TransactionsInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  subaccountId?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<TransactionTime>;
};

export enum UsStateCode {
  Ak = 'AK',
  Al = 'AL',
  Ar = 'AR',
  Az = 'AZ',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  De = 'DE',
  Fl = 'FL',
  Ga = 'GA',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Md = 'MD',
  Me = 'ME',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Ms = 'MS',
  Mt = 'MT',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Va = 'VA',
  Vt = 'VT',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY'
}

export type User = {
  accounts?: Maybe<Array<Maybe<Account>>>;
  bankLink?: Maybe<Array<Maybe<BankLink>>>;
  /** @deprecated Use beneficiaries query instead */
  beneficiaries?: Maybe<Array<Maybe<Beneficiary>>>;
  /** @deprecated Use beneficiaries query instead */
  children?: Maybe<Array<Maybe<Child>>>;
  countryOfCitizenship?: Maybe<Scalars['String']['output']>;
  /** @deprecated No use for the field */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dateOfBirth?: Maybe<Scalars['DateOfBirth']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use invoices query instead */
  invoices?: Maybe<Array<Maybe<Invoice>>>;
  language?: Maybe<UserLanguage>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberVerified?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use firstName instead */
  preferredName?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<AccountProvider>;
  residenceStatus?: Maybe<UserResidenceStatus>;
  status?: Maybe<UserStatus>;
  /** @deprecated Use subscriptions query instead */
  subscriptions?: Maybe<Array<Maybe<Subscription>>>;
  termsAccepted?: Maybe<Scalars['Boolean']['output']>;
  tradeConfirmationsAgreementAccepted?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated No use for the field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userAddress?: Maybe<UserAddress>;
  /** @deprecated No use for the field */
  userAffiliatedExchanges?: Maybe<Array<Maybe<UserAffiliatedExchange>>>;
  /** @deprecated No use for the field */
  userControlCorporations?: Maybe<Array<Maybe<UserControlCorporation>>>;
  userFinancialProfile?: Maybe<UserFinancialProfile>;
  /** @deprecated No use for the field */
  userGovernmentIds?: Maybe<Array<Maybe<UserGovernmentId>>>;
  /** @deprecated No use for the field */
  userInvestmentPrinciples?: Maybe<Array<Maybe<UserInvestmentPrinciple>>>;
  /** @deprecated No use for the field */
  userRestrictions?: Maybe<Array<Maybe<UserRestriction>>>;
  userTaxProfiles?: Maybe<Array<Maybe<UserTaxProfile>>>;
  /** @deprecated No use for the field */
  waitlist?: Maybe<Waitlist>;
};


export type UserSubscriptionsArgs = {
  input: UserSubscriptionInput;
};

export type UserAddress = {
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  /** @deprecated No use for the field */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  unitNo?: Maybe<Scalars['String']['output']>;
  /** @deprecated No use for the field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UserAddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  unitNo?: InputMaybe<Scalars['String']['input']>;
};

export type UserAffiliatedExchange = {
  exchangeMic?: Maybe<AffiliatedExchangeMic>;
  id?: Maybe<Scalars['String']['output']>;
};

export type UserControlCorporation = {
  corporationName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export enum UserDownturnReaction {
  Buy = 'BUY',
  Hold = 'HOLD',
  Sell = 'SELL'
}

export enum UserEmploymentStatus {
  Employed = 'EMPLOYED',
  Retired = 'RETIRED',
  SelfEmployed = 'SELF_EMPLOYED',
  Unemployed = 'UNEMPLOYED'
}

export type UserFinancialProfile = {
  /** @deprecated No use for the field */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  downturnReaction?: Maybe<UserDownturnReaction>;
  employerAddressCity?: Maybe<Scalars['String']['output']>;
  employerAddressCountry?: Maybe<Scalars['String']['output']>;
  employerAddressPostalCode?: Maybe<Scalars['String']['output']>;
  employerAddressState?: Maybe<Scalars['String']['output']>;
  employerAddressStreet?: Maybe<Scalars['String']['output']>;
  employerAddressUnitNo?: Maybe<Scalars['String']['output']>;
  employerName?: Maybe<Scalars['String']['output']>;
  employmentStatus?: Maybe<UserEmploymentStatus>;
  id?: Maybe<Scalars['String']['output']>;
  investmentHorizon?: Maybe<UserInvestmentHorizon>;
  investmentPriority?: Maybe<UserInvestmentPriority>;
  isFamilyPoliticallyExposed?: Maybe<Scalars['Boolean']['output']>;
  isFinraAffiliated?: Maybe<Scalars['Boolean']['output']>;
  isPoliticallyExposed?: Maybe<Scalars['Boolean']['output']>;
  occupationIndustry?: Maybe<OccupationIndustry>;
  occupationTitle?: Maybe<OccupationTitle>;
  trustedContactAddressCity?: Maybe<Scalars['String']['output']>;
  trustedContactAddressCountry?: Maybe<Scalars['String']['output']>;
  trustedContactAddressPostalCode?: Maybe<Scalars['String']['output']>;
  trustedContactAddressState?: Maybe<Scalars['String']['output']>;
  trustedContactAddressStreet?: Maybe<Scalars['String']['output']>;
  trustedContactAddressUnitNo?: Maybe<Scalars['String']['output']>;
  trustedContactEmail?: Maybe<Scalars['String']['output']>;
  trustedContactFirstName?: Maybe<Scalars['String']['output']>;
  trustedContactLastName?: Maybe<Scalars['String']['output']>;
  trustedContactPhoneNumber?: Maybe<Scalars['String']['output']>;
  /** @deprecated No use for the field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UserGovernmentId = {
  country?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  type?: Maybe<UserGovernmentIdType>;
};

export enum UserGovernmentIdType {
  DriversLicense = 'DRIVERS_LICENSE',
  IdentificationCard = 'IDENTIFICATION_CARD',
  Passport = 'PASSPORT',
  TaxId = 'TAX_ID'
}

export enum UserInvestmentHorizon {
  LongTerm = 'LONG_TERM',
  MediumTerm = 'MEDIUM_TERM',
  ShortTerm = 'SHORT_TERM'
}

export type UserInvestmentPrinciple = {
  id?: Maybe<Scalars['String']['output']>;
  principle?: Maybe<InvestmentPrinciple>;
};

export enum UserInvestmentPriority {
  AvoidLosses = 'AVOID_LOSSES',
  BalanceRisk = 'BALANCE_RISK',
  MaximizeReturns = 'MAXIMIZE_RETURNS'
}

export enum UserLanguage {
  EnUs = 'EN_US'
}

export type UserPrefillData = {
  address?: Maybe<UserAddress>;
  dateOfBirth?: Maybe<Scalars['DateOfBirth']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  ssn?: Maybe<Scalars['String']['output']>;
};

export enum UserResidenceStatus {
  Citizen = 'CITIZEN',
  None = 'NONE',
  NonResident = 'NON_RESIDENT',
  Resident = 'RESIDENT'
}

export type UserRestriction = {
  id?: Maybe<Scalars['String']['output']>;
  symbol?: Maybe<Scalars['String']['output']>;
};

export enum UserStatus {
  Active = 'ACTIVE',
  Closed = 'CLOSED',
  Declined = 'DECLINED',
  Frozen = 'FROZEN',
  New = 'NEW',
  Pending = 'PENDING',
  PendingClosure = 'PENDING_CLOSURE',
  VerificationFailed = 'VERIFICATION_FAILED',
  VerificationInProgress = 'VERIFICATION_IN_PROGRESS'
}

export type UserSubscriptionInput = {
  statuses: Array<InputMaybe<SubscriptionStatus>>;
};

export enum UserTaxIdType {
  AustraliaAbn = 'AUSTRALIA_ABN',
  AustraliaTfn = 'AUSTRALIA_TFN',
  FranceSpi = 'FRANCE_SPI',
  GermanyTaxId = 'GERMANY_TAX_ID',
  Other = 'OTHER',
  UkUtr = 'UK_UTR',
  UsaSsn = 'USA_SSN'
}

export type UserTaxProfile = {
  countryOfTaxResidence: Scalars['String']['output'];
  /** @deprecated No use for the field */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  stateOfTaxResidence: Scalars['String']['output'];
  taxId: Scalars['String']['output'];
  taxIdType: UserTaxIdType;
  /** @deprecated No use for the field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ValidateUserPrefill = {
  address: UserAddressInput;
  dateOfBirth: Scalars['DateOfBirth']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  ssn: Scalars['String']['input'];
};

export type VerifyPhoneNumber = {
  code: Scalars['String']['input'];
};

export type Waitlist = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export enum WithdrawalType {
  Withdrawal = 'WITHDRAWAL',
  WithdrawalAll = 'WITHDRAWAL_ALL'
}

export type BankLinkFragmentFragment = { id?: string | null, status?: BankLinkStatus | null, providerInstitutionId?: string | null, assets?: { name?: string | null, logo?: string | null } | null };

export type BankAccountFragmentFragment = { id?: string | null, bankAccountId?: string | null, accountNumber?: string | null, routingNumber?: string | null, name?: string | null, useForBilling?: boolean | null, assetLogo?: string | null, assetColor?: string | null };

export type GoalFragmentFragment = { id?: string | null, name?: string | null, description?: string | null, type?: GoalType | null, targetAmountInCents?: number | null, currentAmountInCents?: number | null, startDate?: any | null, endDate?: any | null, projectedRateOfReturn?: number | null, contributionsAfter18?: boolean | null, status?: GoalStatus | null, shared?: boolean | null, partners?: Array<{ id?: string | null, firstName?: string | null, lastName?: string | null } | null> | null, sips?: Array<{ id?: string | null, recurringDepositInCents?: number | null, recurringDepositSchedule?: SipFrequency | null, paused?: boolean | null, status?: SipStatus | null } | null> | null };

export type InviteFragmentFragment = { id?: string | null, goalId?: string | null, phoneNumber?: string | null, status?: ShareGoalInviteStatus | null, expiry?: any | null };

export type PerformanceGraphFragmentFragment = { grossReturnAbsolute?: number | null, grossReturnPercentage?: number | null, nodes?: Array<{ value: number, timestamp: any } | null> | null };

export type SipFragmentFragment = { id?: string | null, recurringDepositInCents?: number | null, recurringDepositSchedule?: SipFrequency | null, paused?: boolean | null, status?: SipStatus | null };

export type TransactionFragmentFragment = { id?: string | null, label?: TransactionLabel | null, type?: TransactionType | null, status?: TransactionStatus | null, description?: string | null, amountInCents?: number | null, reason?: string | null, date?: string | null };

export type UserFragmentFragment = { id?: string | null, provider?: AccountProvider | null, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, phoneNumberVerified?: boolean | null, dateOfBirth?: any | null, language?: UserLanguage | null, residenceStatus?: UserResidenceStatus | null, countryOfCitizenship?: string | null, status?: UserStatus | null, termsAccepted?: boolean | null, tradeConfirmationsAgreementAccepted?: boolean | null, userAddress?: { id?: string | null, unitNo?: string | null, street?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null } | null, userFinancialProfile?: { id?: string | null, investmentPriority?: UserInvestmentPriority | null, investmentHorizon?: UserInvestmentHorizon | null, downturnReaction?: UserDownturnReaction | null, employmentStatus?: UserEmploymentStatus | null, employerName?: string | null, employerAddressUnitNo?: string | null, employerAddressStreet?: string | null, employerAddressCity?: string | null, employerAddressState?: string | null, employerAddressCountry?: string | null, employerAddressPostalCode?: string | null, occupationTitle?: OccupationTitle | null, occupationIndustry?: OccupationIndustry | null, isFinraAffiliated?: boolean | null, isPoliticallyExposed?: boolean | null, isFamilyPoliticallyExposed?: boolean | null, trustedContactFirstName?: string | null, trustedContactLastName?: string | null, trustedContactEmail?: string | null, trustedContactPhoneNumber?: string | null, trustedContactAddressUnitNo?: string | null, trustedContactAddressStreet?: string | null, trustedContactAddressCity?: string | null, trustedContactAddressState?: string | null, trustedContactAddressCountry?: string | null, trustedContactAddressPostalCode?: string | null } | null, userTaxProfiles?: Array<{ id?: string | null, taxId: string, taxIdType: UserTaxIdType, countryOfTaxResidence: string, stateOfTaxResidence: string } | null> | null };

export type BeneficiariesFragmentFragment = { id?: string | null, type?: BeneficiaryType | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: any | null, goals?: Array<{ id?: string | null, name?: string | null, description?: string | null, type?: GoalType | null, targetAmountInCents?: number | null, currentAmountInCents?: number | null, startDate?: any | null, endDate?: any | null, projectedRateOfReturn?: number | null, contributionsAfter18?: boolean | null, status?: GoalStatus | null, shared?: boolean | null, partners?: Array<{ id?: string | null, firstName?: string | null, lastName?: string | null } | null> | null, sips?: Array<{ id?: string | null, recurringDepositInCents?: number | null, recurringDepositSchedule?: SipFrequency | null, paused?: boolean | null, status?: SipStatus | null } | null> | null } | null> | null };

export type ProcessPublicTokenMutationVariables = Exact<{
  institutionId: Scalars['String']['input'];
  publicToken: Scalars['String']['input'];
}>;


export type ProcessPublicTokenMutation = { processPublicToken?: boolean | null };

export type LoginUserMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginUserMutation = { loginUser: { token: string } };

export type RegisterUserMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  promotionCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type RegisterUserMutation = { registerUser: { token: string } };

export type ResetPasswordMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
}>;


export type ResetPasswordMutation = { resetPassword: boolean };

export type CreateOneTimeDepositMutationVariables = Exact<{
  goalId: Scalars['String']['input'];
  bankAccountId?: InputMaybe<Scalars['String']['input']>;
  amountInCents: Scalars['Int']['input'];
  executionDate: Scalars['Date']['input'];
}>;


export type CreateOneTimeDepositMutation = { createOneTimeDeposit: { id?: string | null, label?: TransactionLabel | null, type?: TransactionType | null, status?: TransactionStatus | null, description?: string | null, amountInCents?: number | null, reason?: string | null, date?: string | null } };

export type AddGoalMutationVariables = Exact<{
  beneficiaryId: Scalars['String']['input'];
  goalType?: InputMaybe<GoalType>;
  goalName?: InputMaybe<Scalars['String']['input']>;
  accountType: AccountType;
  targetYear?: InputMaybe<Scalars['Int']['input']>;
  targetAmountInCents: Scalars['Float']['input'];
  recurringDepositInCents: Scalars['Int']['input'];
  recurringDepositSchedule: SipFrequency;
  projectedRateOfReturn?: InputMaybe<Scalars['Float']['input']>;
  contributionsAfter18?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AddGoalMutation = { addGoal?: { id?: string | null, name?: string | null, description?: string | null, type?: GoalType | null, targetAmountInCents?: number | null, currentAmountInCents?: number | null, startDate?: any | null, endDate?: any | null, status?: GoalStatus | null, contributionsAfter18?: boolean | null, projectedRateOfReturn?: number | null } | null };

export type EditGoalMutationVariables = Exact<{
  goalId: Scalars['String']['input'];
  goalName?: InputMaybe<Scalars['String']['input']>;
  goalType?: InputMaybe<GoalType>;
  projectedRateOfReturn?: InputMaybe<Scalars['Float']['input']>;
  contributionsAfter18?: InputMaybe<Scalars['Boolean']['input']>;
  targetYear?: InputMaybe<Scalars['Int']['input']>;
  targetAmountInCents?: InputMaybe<Scalars['Float']['input']>;
}>;


export type EditGoalMutation = { editGoal?: { id?: string | null, name?: string | null, description?: string | null, type?: GoalType | null, targetAmountInCents?: number | null, currentAmountInCents?: number | null, startDate?: any | null, endDate?: any | null, status?: GoalStatus | null, contributionsAfter18?: boolean | null, projectedRateOfReturn?: number | null } | null };

export type InviteToShareGoalMutationVariables = Exact<{
  goalId: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
}>;


export type InviteToShareGoalMutation = { inviteToShareGoal?: { id?: string | null, goalId?: string | null, phoneNumber?: string | null, status?: ShareGoalInviteStatus | null, expiry?: any | null } | null };

export type DeleteInviteToShareGoalMutationVariables = Exact<{
  shareGoalInviteId: Scalars['String']['input'];
}>;


export type DeleteInviteToShareGoalMutation = { deleteInviteToShareGoal?: boolean | null };

export type ResendInviteToShareGoalMutationVariables = Exact<{
  shareGoalInviteId: Scalars['String']['input'];
}>;


export type ResendInviteToShareGoalMutation = { resendInviteToShareGoal?: { id?: string | null, goalId?: string | null, phoneNumber?: string | null, status?: ShareGoalInviteStatus | null, expiry?: any | null } | null };

export type ActionShareGoalInviteMutationVariables = Exact<{
  shareGoalInviteId: Scalars['String']['input'];
  action: ShareGoalInviteAction;
  accountType?: InputMaybe<AccountType>;
  projectedRateOfReturn?: InputMaybe<Scalars['Float']['input']>;
  contributionsAfter18?: InputMaybe<Scalars['Boolean']['input']>;
  recurringDepositInCents?: InputMaybe<Scalars['Int']['input']>;
  recurringDepositSchedule?: InputMaybe<SipFrequency>;
}>;


export type ActionShareGoalInviteMutation = { actionShareGoalInvite?: { id?: string | null, name?: string | null, description?: string | null, type?: GoalType | null, targetAmountInCents?: number | null, currentAmountInCents?: number | null, startDate?: any | null, endDate?: any | null, projectedRateOfReturn?: number | null, contributionsAfter18?: boolean | null, status?: GoalStatus | null, shared?: boolean | null, partners?: Array<{ id?: string | null, firstName?: string | null, lastName?: string | null } | null> | null, sips?: Array<{ id?: string | null, recurringDepositInCents?: number | null, recurringDepositSchedule?: SipFrequency | null, paused?: boolean | null, status?: SipStatus | null } | null> | null } | null };

export type RemovePartnerFromGoalMutationVariables = Exact<{
  goalId: Scalars['String']['input'];
  partnerId: Scalars['String']['input'];
}>;


export type RemovePartnerFromGoalMutation = { removePartnerFromGoal?: { id?: string | null, name?: string | null, description?: string | null, type?: GoalType | null, targetAmountInCents?: number | null, currentAmountInCents?: number | null, startDate?: any | null, endDate?: any | null, projectedRateOfReturn?: number | null, contributionsAfter18?: boolean | null, status?: GoalStatus | null, shared?: boolean | null, partners?: Array<{ id?: string | null, firstName?: string | null, lastName?: string | null } | null> | null, sips?: Array<{ id?: string | null, recurringDepositInCents?: number | null, recurringDepositSchedule?: SipFrequency | null, paused?: boolean | null, status?: SipStatus | null } | null> | null } | null };

export type SetUserFinancialProfileMutationVariables = Exact<{
  investmentPriority?: InputMaybe<UserInvestmentPriority>;
  investmentHorizon?: InputMaybe<UserInvestmentHorizon>;
  downturnReaction?: InputMaybe<UserDownturnReaction>;
  employmentStatus?: InputMaybe<UserEmploymentStatus>;
  employerName?: InputMaybe<Scalars['String']['input']>;
  employerAddressUnitNo?: InputMaybe<Scalars['String']['input']>;
  employerAddressStreet?: InputMaybe<Scalars['String']['input']>;
  employerAddressCity?: InputMaybe<Scalars['String']['input']>;
  employerAddressState?: InputMaybe<Scalars['String']['input']>;
  employerAddressCountry?: InputMaybe<Scalars['String']['input']>;
  employerAddressPostalCode?: InputMaybe<Scalars['String']['input']>;
  occupation?: InputMaybe<OccupationTitle>;
  industry?: InputMaybe<OccupationIndustry>;
}>;


export type SetUserFinancialProfileMutation = { setUserFinancialProfile?: { id?: string | null } | null };

export type ChangeRecurringDepositMutationVariables = Exact<{
  sipId: Scalars['String']['input'];
  amountInCents?: InputMaybe<Scalars['Int']['input']>;
  frequency?: InputMaybe<SipFrequency>;
  pause?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ChangeRecurringDepositMutation = { changeRecurringDeposit: { id?: string | null, recurringDepositInCents?: number | null, recurringDepositSchedule?: SipFrequency | null, status?: SipStatus | null } };

export type VerifyPhoneNumberMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type VerifyPhoneNumberMutation = { verifyPhoneNumber?: boolean | null };

export type VerifyPromotionCodeMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type VerifyPromotionCodeMutation = { verifyPromotionCode?: { name?: string | null, code?: string | null, active?: boolean | null, amountOff?: number | null, percentOff?: number | null } | null };

export type CreateTermsConsentMutationVariables = Exact<{
  viewedTimestamp: Scalars['DateTime']['input'];
}>;


export type CreateTermsConsentMutation = { createTermsConsent?: boolean | null };

export type CreateTradeConfirmationsConsentMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateTradeConfirmationsConsentMutation = { createTradeConfirmationsConsent?: boolean | null };

export type InitiateUserPrefillMutationVariables = Exact<{ [key: string]: never; }>;


export type InitiateUserPrefillMutation = { initiateUserPrefill?: { redirectUrl?: string | null } | null };

export type ValidateUserPrefillMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  dateOfBirth: Scalars['DateOfBirth']['input'];
  address: UserAddressInput;
  ssn: Scalars['String']['input'];
}>;


export type ValidateUserPrefillMutation = { validateUserPrefill?: boolean | null };

export type SetUserIdentityMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<UserAddressInput>;
  countryOfCitizenship?: InputMaybe<Scalars['String']['input']>;
  residenceStatus?: InputMaybe<UserResidenceStatus>;
}>;


export type SetUserIdentityMutation = { setUserIdentity?: { id?: string | null, provider?: AccountProvider | null, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, phoneNumberVerified?: boolean | null, dateOfBirth?: any | null, language?: UserLanguage | null, residenceStatus?: UserResidenceStatus | null, countryOfCitizenship?: string | null, status?: UserStatus | null, termsAccepted?: boolean | null, tradeConfirmationsAgreementAccepted?: boolean | null, userAddress?: { id?: string | null, unitNo?: string | null, street?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null } | null, userFinancialProfile?: { id?: string | null, investmentPriority?: UserInvestmentPriority | null, investmentHorizon?: UserInvestmentHorizon | null, downturnReaction?: UserDownturnReaction | null, employmentStatus?: UserEmploymentStatus | null, employerName?: string | null, employerAddressUnitNo?: string | null, employerAddressStreet?: string | null, employerAddressCity?: string | null, employerAddressState?: string | null, employerAddressCountry?: string | null, employerAddressPostalCode?: string | null, occupationTitle?: OccupationTitle | null, occupationIndustry?: OccupationIndustry | null, isFinraAffiliated?: boolean | null, isPoliticallyExposed?: boolean | null, isFamilyPoliticallyExposed?: boolean | null, trustedContactFirstName?: string | null, trustedContactLastName?: string | null, trustedContactEmail?: string | null, trustedContactPhoneNumber?: string | null, trustedContactAddressUnitNo?: string | null, trustedContactAddressStreet?: string | null, trustedContactAddressCity?: string | null, trustedContactAddressState?: string | null, trustedContactAddressCountry?: string | null, trustedContactAddressPostalCode?: string | null } | null, userTaxProfiles?: Array<{ id?: string | null, taxId: string, taxIdType: UserTaxIdType, countryOfTaxResidence: string, stateOfTaxResidence: string } | null> | null } | null };

export type SetUserTaxProfileMutationVariables = Exact<{
  taxId: Scalars['String']['input'];
  taxIdType: UserTaxIdType;
  countryOfTaxResidence: Scalars['String']['input'];
  stateOfTaxResidence: Scalars['String']['input'];
}>;


export type SetUserTaxProfileMutation = { setUserTaxProfile?: { id?: string | null, provider?: AccountProvider | null, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, phoneNumberVerified?: boolean | null, dateOfBirth?: any | null, language?: UserLanguage | null, residenceStatus?: UserResidenceStatus | null, countryOfCitizenship?: string | null, status?: UserStatus | null, termsAccepted?: boolean | null, tradeConfirmationsAgreementAccepted?: boolean | null, userAddress?: { id?: string | null, unitNo?: string | null, street?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null } | null, userFinancialProfile?: { id?: string | null, investmentPriority?: UserInvestmentPriority | null, investmentHorizon?: UserInvestmentHorizon | null, downturnReaction?: UserDownturnReaction | null, employmentStatus?: UserEmploymentStatus | null, employerName?: string | null, employerAddressUnitNo?: string | null, employerAddressStreet?: string | null, employerAddressCity?: string | null, employerAddressState?: string | null, employerAddressCountry?: string | null, employerAddressPostalCode?: string | null, occupationTitle?: OccupationTitle | null, occupationIndustry?: OccupationIndustry | null, isFinraAffiliated?: boolean | null, isPoliticallyExposed?: boolean | null, isFamilyPoliticallyExposed?: boolean | null, trustedContactFirstName?: string | null, trustedContactLastName?: string | null, trustedContactEmail?: string | null, trustedContactPhoneNumber?: string | null, trustedContactAddressUnitNo?: string | null, trustedContactAddressStreet?: string | null, trustedContactAddressCity?: string | null, trustedContactAddressState?: string | null, trustedContactAddressCountry?: string | null, trustedContactAddressPostalCode?: string | null } | null, userTaxProfiles?: Array<{ id?: string | null, taxId: string, taxIdType: UserTaxIdType, countryOfTaxResidence: string, stateOfTaxResidence: string } | null> | null } | null };

export type AddBeneficiaryMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateOfBirth']['input']>;
  type: BeneficiaryType;
}>;


export type AddBeneficiaryMutation = { addBeneficiary?: { id?: string | null, type?: BeneficiaryType | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: any | null, goals?: Array<{ id?: string | null, name?: string | null, description?: string | null, type?: GoalType | null, targetAmountInCents?: number | null, currentAmountInCents?: number | null, startDate?: any | null, endDate?: any | null, status?: GoalStatus | null } | null> | null } | null };

export type AccountQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountQuery = { account?: Array<{ id?: string | null, type?: AccountType | null, title?: string | null, status?: AccountStatus | null, balanceInCents?: number | null, subaccounts?: Array<{ id?: string | null, childId?: string | null, type?: SubaccountType | null, title?: string | null, balanceInCents?: number | null, riskScore?: RiskScore | null, enableDynamicRisk?: boolean | null } | null> | null }> | null };

export type AddressPredictionsQueryVariables = Exact<{
  input: Scalars['String']['input'];
}>;


export type AddressPredictionsQuery = { addressPredictions?: { predictions?: Array<{ placeId: string, description: string } | null> | null } | null };

export type AddressDetailsQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
}>;


export type AddressDetailsQuery = { addressDetails?: { streetName?: string | null, streetNumber?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null } | null };

export type BusinessAddressQueryVariables = Exact<{
  input: Scalars['String']['input'];
}>;


export type BusinessAddressQuery = { businessAddress?: { address?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null };

export type CountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CountriesQuery = { countries?: any | null };

export type IsSupportedVersionQueryVariables = Exact<{
  version: Scalars['String']['input'];
}>;


export type IsSupportedVersionQuery = { isSupportedVersion?: boolean | null };

export type GetBankLinkTokenQueryVariables = Exact<{
  input?: InputMaybe<GetBankLinkTokenInput>;
}>;


export type GetBankLinkTokenQuery = { getBankLinkToken?: { provider: string, token: string } | null };

export type GoalDetailsBreakdownQueryVariables = Exact<{
  beneficiaryId?: InputMaybe<Scalars['String']['input']>;
  goalId?: InputMaybe<Scalars['String']['input']>;
  nodeCount?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GoalDetailsBreakdownQuery = { oneDay: { grossReturnAbsolute?: number | null, grossReturnPercentage?: number | null, nodes?: Array<{ value: number, timestamp: any } | null> | null }, oneWeek: { grossReturnAbsolute?: number | null, grossReturnPercentage?: number | null, nodes?: Array<{ value: number, timestamp: any } | null> | null }, oneMonth: { grossReturnAbsolute?: number | null, grossReturnPercentage?: number | null, nodes?: Array<{ value: number, timestamp: any } | null> | null }, sixMonth: { grossReturnAbsolute?: number | null, grossReturnPercentage?: number | null, nodes?: Array<{ value: number, timestamp: any } | null> | null }, oneYear: { grossReturnAbsolute?: number | null, grossReturnPercentage?: number | null, nodes?: Array<{ value: number, timestamp: any } | null> | null }, fiveYear: { grossReturnAbsolute?: number | null, grossReturnPercentage?: number | null, nodes?: Array<{ value: number, timestamp: any } | null> | null }, portfolioBreakdown: { totalValueInCents?: number | null, contributionsInCents?: number | null, returnsInCents?: number | null, sectorExposures?: Array<{ name: PortfolioSectorExposureNames, factorPercentage: number } | null> | null, assetClassExposures?: Array<{ name: PortfolioAssetExposureNames, factorPercentage: number } | null> | null }, portfolioPositions: Array<{ symbol: string, name: string, shares: number, sharePriceInCents: number, totalValueInCents: number, changeTodayAmountInCents?: number | null, changeTodayPercentage?: number | null } | null> };

export type SentShareGoalInvitesQueryVariables = Exact<{
  goalId: Scalars['String']['input'];
}>;


export type SentShareGoalInvitesQuery = { sentShareGoalInvites?: Array<{ id?: string | null, goalId?: string | null, phoneNumber?: string | null, status?: ShareGoalInviteStatus | null, expiry?: any | null } | null> | null };

export type ReceivedShareGoalInvitesQueryVariables = Exact<{ [key: string]: never; }>;


export type ReceivedShareGoalInvitesQuery = { receivedShareGoalInvites?: Array<{ id?: string | null, goalName?: string | null, goalType?: GoalType | null, inviterFirstName?: string | null, inviterLastName?: string | null, recurringDepositInCents?: number | null, recurringDepositSchedule?: SipFrequency | null, status?: ShareGoalInviteStatus | null, expiry?: any | null } | null> | null };

export type PortfolioPerformanceGraphQueryVariables = Exact<{
  beneficiaryId?: InputMaybe<Scalars['String']['input']>;
  goalId?: InputMaybe<Scalars['String']['input']>;
  nodeCount?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PortfolioPerformanceGraphQuery = { oneDay: { grossReturnAbsolute?: number | null, grossReturnPercentage?: number | null, nodes?: Array<{ value: number, timestamp: any } | null> | null }, oneWeek: { grossReturnAbsolute?: number | null, grossReturnPercentage?: number | null, nodes?: Array<{ value: number, timestamp: any } | null> | null }, oneMonth: { grossReturnAbsolute?: number | null, grossReturnPercentage?: number | null, nodes?: Array<{ value: number, timestamp: any } | null> | null }, sixMonth: { grossReturnAbsolute?: number | null, grossReturnPercentage?: number | null, nodes?: Array<{ value: number, timestamp: any } | null> | null }, oneYear: { grossReturnAbsolute?: number | null, grossReturnPercentage?: number | null, nodes?: Array<{ value: number, timestamp: any } | null> | null }, fiveYear: { grossReturnAbsolute?: number | null, grossReturnPercentage?: number | null, nodes?: Array<{ value: number, timestamp: any } | null> | null } };

export type UserPrefillDataQueryVariables = Exact<{ [key: string]: never; }>;


export type UserPrefillDataQuery = { userPrefillData?: { firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, dateOfBirth?: any | null, ssn?: string | null, address?: { unitNo?: string | null, street?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null } | null } | null };

export type TransactionsQueryVariables = Exact<{
  size?: InputMaybe<Scalars['Int']['input']>;
  accountId?: InputMaybe<Scalars['String']['input']>;
  subaccountId?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<TransactionTime>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type TransactionsQuery = { transactions?: { size?: number | null, nextCursor?: string | null, elements: Array<{ id?: string | null, label?: TransactionLabel | null, type?: TransactionType | null, status?: TransactionStatus | null, description?: string | null, amountInCents?: number | null, reason?: string | null, date?: string | null } | null> } | null };

export type UserQueryVariables = Exact<{ [key: string]: never; }>;


export type UserQuery = { user?: { id?: string | null, provider?: AccountProvider | null, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, phoneNumberVerified?: boolean | null, dateOfBirth?: any | null, language?: UserLanguage | null, residenceStatus?: UserResidenceStatus | null, countryOfCitizenship?: string | null, status?: UserStatus | null, termsAccepted?: boolean | null, tradeConfirmationsAgreementAccepted?: boolean | null, userAddress?: { id?: string | null, unitNo?: string | null, street?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null } | null, userFinancialProfile?: { id?: string | null, investmentPriority?: UserInvestmentPriority | null, investmentHorizon?: UserInvestmentHorizon | null, downturnReaction?: UserDownturnReaction | null, employmentStatus?: UserEmploymentStatus | null, employerName?: string | null, employerAddressUnitNo?: string | null, employerAddressStreet?: string | null, employerAddressCity?: string | null, employerAddressState?: string | null, employerAddressCountry?: string | null, employerAddressPostalCode?: string | null, occupationTitle?: OccupationTitle | null, occupationIndustry?: OccupationIndustry | null, isFinraAffiliated?: boolean | null, isPoliticallyExposed?: boolean | null, isFamilyPoliticallyExposed?: boolean | null, trustedContactFirstName?: string | null, trustedContactLastName?: string | null, trustedContactEmail?: string | null, trustedContactPhoneNumber?: string | null, trustedContactAddressUnitNo?: string | null, trustedContactAddressStreet?: string | null, trustedContactAddressCity?: string | null, trustedContactAddressState?: string | null, trustedContactAddressCountry?: string | null, trustedContactAddressPostalCode?: string | null } | null, userTaxProfiles?: Array<{ id?: string | null, taxId: string, taxIdType: UserTaxIdType, countryOfTaxResidence: string, stateOfTaxResidence: string } | null> | null } | null, beneficiaries?: Array<{ id?: string | null, type?: BeneficiaryType | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: any | null, goals?: Array<{ id?: string | null, name?: string | null, description?: string | null, type?: GoalType | null, targetAmountInCents?: number | null, currentAmountInCents?: number | null, startDate?: any | null, endDate?: any | null, projectedRateOfReturn?: number | null, contributionsAfter18?: boolean | null, status?: GoalStatus | null, shared?: boolean | null, partners?: Array<{ id?: string | null, firstName?: string | null, lastName?: string | null } | null> | null, sips?: Array<{ id?: string | null, recurringDepositInCents?: number | null, recurringDepositSchedule?: SipFrequency | null, paused?: boolean | null, status?: SipStatus | null } | null> | null } | null> | null } | null> | null, getBankLinks?: Array<{ id?: string | null, status?: BankLinkStatus | null, providerInstitutionId?: string | null, assets?: { name?: string | null, logo?: string | null } | null } | null> | null, getBankAccounts?: Array<{ id?: string | null, bankAccountId?: string | null, accountNumber?: string | null, routingNumber?: string | null, name?: string | null, useForBilling?: boolean | null, assetLogo?: string | null, assetColor?: string | null }> | null };

export type IndustriesQueryVariables = Exact<{ [key: string]: never; }>;


export type IndustriesQuery = { industries?: any | null };

export type OccupationsQueryVariables = Exact<{ [key: string]: never; }>;


export type OccupationsQuery = { occupations?: any | null };

export type UserKycCompletionLinkQueryVariables = Exact<{ [key: string]: never; }>;


export type UserKycCompletionLinkQuery = { userKYCCompletionLink?: string | null };
